import { useState, useCallback } from "react";
import { getFilterNotesByTopicsURL } from "../utils/ConstantsURL";

export const useFilterNotesByTopics = (token) => {
  const [notas, setNotas] = useState([]);
  const [topicWords, setTopicWords] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const fetchNotasByTopic = useCallback(async (filters) => {
    setLoading(true);
    setError(null);

    try {
      const response = await fetch(getFilterNotesByTopicsURL(), {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(filters),
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || "Ocurrió un error al obtener las notas por tema.");
      }

      const data = await response.json();
      setNotas(data.notes || []);
      setTopicWords(data.topicWords || []);
      return data;
    } catch (err) {
      setError(err);
      setNotas([]);
      setTopicWords([]);
      return { notes: [], topicWords: [] };
    } finally {
      setLoading(false);
    }
  }, [token]);

  return { notas, topicWords, loading, error, fetchNotasByTopic };
};
